module.exports = __webpack_public_path__ + "static/media/loginu.3ef1f161.svg";